import { RrcProfilesManager } from '@ots-frontend/ots-ui-tw';
import { Link, Route } from 'react-router-dom';
import { ContainerClusterDataTablePageRoute } from '../../../pages/ContainerClusterDataTablePage/ContainerClusterDataTablePage';
import { ContainerClusterProfilePageRoute } from '../../../pages/ContainerClusterProfilePage/ContainerClusterProfilePage';
import { ContainerProfilePageRoute } from '../../../pages/ContainerProfilePage/ContainerProfilePage';
import { PersonDataTablePage } from '../../../pages/PersonDataTablePage/PersonDataTablePage';
import { PersonFormPageRoute } from '../../../pages/PersonFormPage/PersonFormPage';
import { PersonProfilePageRoute } from '../../../pages/PersonProfilePage/PersonProfilePage';
import { RouteDataTablePage } from '../../../pages/RouteDataTablePage/RouteDataTablePage';
import { RouteProfilePageRoute } from '../../../pages/RouteProfilePage/RouteProfilePage';
import { SiteDataTablePage } from '../../../pages/SiteDataTablePage/SiteDataTablePage';
import { SiteProfilePageRoute } from '../../../pages/SiteProfilePage/SiteProfilePage';
import { TrailerDataTablePage } from '../../../pages/TrailerDataTablePage/TrailerDataTablePage';
import { TrailerFormPageRoute } from '../../../pages/TrailerFormPage/TrailerFormPage';
import { TrailerProfilePageRoute } from '../../../pages/TrailerProfilePage/TrailerProfilePage';
import { VehicleDataTablePage } from '../../../pages/VehicleDataTablePage/VehicleDataTablePage';
import { VehicleFormPageRoute } from '../../../pages/VehicleFormPage/VehicleFormPage';
import { VehicleProfilePageRoute } from '../../../pages/VehicleProfilePage/VehicleProfilePage';
import { IndexComponent } from '../IndexComponent/IndexComponent';
import { lazy, ReactNode, Suspense } from 'react';
import { MeterDataTablePage } from '../../../pages/MeterDataTablePage/MeterDataTablePage';
import { MeterProfilePageRoute } from '../../../pages/MeterProfilePage/MeterProfilePage';
import { ContainerLevelSearchPageRoute } from '../../../pages/ContainerLevelSearchPage/ContainerLevelSearchPage';
import { SiteMileageDataTablePage } from '../../../pages/SiteMileageDataTablePage/SiteMileageDataTablePage';
import { Anchor } from '@mantine/core';
import { ActivityPeriodProfilePageRoute } from '../../../pages/ActivityPeriodProfilePage/ActivityPeriodProfilePage';
import { ActivityPeriodTicketDataTablePageRoute } from '../../../pages/ActivityPeriodTicketDataTablePage/ActivityPeriodTicketDataTablePage';
import { ObjectMappingFormPageRoute } from '../../../pages/ObjectMappingFormPage/ObjectMappingFormPage';
import { SiteSiteAssignmentBulkFormPageRoute } from '../../../pages/SiteSiteAssignmentBulkFormPage/SiteSiteAssignmentBulkFormPage';
import { CompanySiteAssignmentBulkFormPageRoute } from '../../../pages/CompanySiteAssignmentBulkFormPage/CompanySiteAssignmentBulkFormPage';
import { MeterFormPageRoute } from '../../../pages/MeterFormPage/MeterFormPage';
import { SiteSiteAssignmentFormPageRoute } from '../../../pages/SiteSiteAssignmentFormPage/SiteSiteAssignmentFormPage';
import { CompanySiteAssignmentFormPageRoute } from '../../../pages/CompanySiteAssignmentFormPage/CompanySiteAssignmentFormPage';
import { WellDataTablePage } from '../../../pages/WellDataTablePage/WellDataTablePage';
import { WellProfilePageRoute } from '../../../pages/WellProfilePage/WellProfilePage';
import { TransportFormPreferencePageRoute } from '../../../pages/TransportFormPreferencePage/TransportFormPreferencePage';
import { PermissionDataTablePageRoute } from '../../../pages/PermissionDataTablePage/PermissionDataTablePage';
import { RoleDataTablePageRoute } from '../../../pages/RoleDataTablePage/RoleDataTablePage';
import { ABACPolicyDataTablePageRoute } from '../../../pages/ABACPolicyDataTablePage/ABACPolicyDataTablePage';
import { ABACPolicyFormPageRoute } from '../../../pages/ABACPolicyFormPage/ABACPolicyFormPage';
import { RoleFormPageRoute } from '../../../pages/RoleFormPage/RoleFormPage';

import { RoleProfilePageRoute } from '../../../pages/RoleProfilePage/RoleProfilePage';
import { PermissionProfilePageRoute } from '../../../pages/PermissionProfilePage/PermissionProfilePage';
import { ABACPolicyProfilePageRoute } from '../../../pages/ABACPolicyProfilePage/ABACPolicyProfilePage';
import { CompanyDisposalReportFormPageRoute } from '../../../pages/CompanyDisposalReportFormPage/CompanyDisposalReportFormPage';
import { TtaDisputeReportFormPageRoute } from '../../../pages/TtaDisputeReportFormPage/TtaDisputeReportFormPage';
import { OnSiteTimeReportFormPageRoute } from '../../../pages/OnSiteTimeReportFormPage/OnSiteTimeReportFormPage';
import { CompanyTransportServicesReportFormPageRoute } from '../../../pages/CompanyTransportServicesReportFormPage/CompanyTransportServicesReportFormPage';
import { ChatPageRoute } from '../../../pages/ChatPage/ChatPage';
import { SiteFormPageRoute } from '../../../pages/SiteFormPage/SiteFormPage';
import { ContainerDataTablePage } from '../../../pages/ContainerDataTablePage/ContainerDataTablePage';
import { ContainerFormPageRoute } from '../../../pages/ContainerFormPage/ContainerFormPage';
import { GeofenceSiteGroupDataTablePage } from '../../../pages/GeofenceSiteGroupDataTablePage/GeofenceSiteGroupDataTablePage';
import { GeofenceSiteGroupProfilePageRoute } from '../../../pages/GeofenceSiteGroupProfilePage/GeofenceSiteGroupProfilePage';
import { GeofenceSiteGroupFormPageRoute } from '../../../pages/GeofenceSiteGroupFormPage/GeofenceSiteGroupFormPage';
import { GeofenceFormPageRoute } from '../../../pages/GeofenceFormPage/GeofenceFormPage';
import { ObjectComboMappingFormPageRoute } from '../../../pages/ObjectComboMappingFormPage/ObjectComboMappingFormPage';
import { OperatingAreaDataTablePageRoute } from '../../../pages/OperatingAreaDataTablePage/OperatingAreaDataTablePage';
import { OperatingAreaProfilePageRoute } from '../../../pages/OperatingAreaProfilePage/OperatingAreaProfilePage';
import { RrcLocationProfileFormPageRoute } from '../../../pages/RrcLocationProfileFormPage/RrcLocationProfileFormPage';
import { RrcLocationProfileProfilePageRoute } from '../../../pages/RrcLocationProfileProfilePage/RrcLocationProfileProfilePage';
import { RrcLocationProfileKeyProfilePageRoute, RrcLocationProfilesPageRoute } from '../../../pages/RrcLocationProfileProfilePage/RrcLocationProfileKeyProfilePage';
import { RrcCompanyProfileProfilePageRoute } from '../../../pages/RrcCompanyProfileProfilePage/RrcCompanyProfileProfilePage';
import { RrcCompanyProfileKeyProfilePageRoute, RrcCompanyProfilesPageRoute } from '../../../pages/RrcCompanyProfileProfilePage/RrcCompanyProfileKeyProfilePage';
import { RrcCompanyProfileFormPageRoute } from '../../../pages/RrcCompanyProfileFormPage/RrcCompanyProfileFormPage';
import { CompanyDataTablePage } from '../../../pages/CompanyDataTablePage/CompanyDataTablePage';
import { CompanyProfilePageRoute } from '../../../pages/CompanyProfilePage/CompanyProfilePage';
import { RrcEp9WasteProfileProfilePageRoute } from '../../../pages/RrcEp9WasteProfileProfilePage/RrcEp9WasteProfileProfilePage';
import { RrcEp9WasteProfileKeyProfilePageRoute, RrcEp9WasteProfilesPageRoute } from '../../../pages/RrcEp9WasteProfileProfilePage/RrcEp9WasteProfileKeyProfilePage';
import { RrcEp9WasteProfileFormPageRoute } from '../../../pages/RrcEp9WasteProfileFormPage/RrcEp9WasteProfileFormPage';
import { RrcEp10WasteManifestProfilePageRoute } from '../../../pages/RrcEp10WasteManifestProfilePage/RrcEp10WasteManifestProfilePage';
import { RrcEp10WasteManifestKeyProfilePageRoute } from '../../../pages/RrcEp10WasteManifestProfilePage/RrcEp10WasteManifestKeyProfilePage';
import { ServiceTypeProfilePageRoute } from '../../../pages/ServiceTypeProfilePage/ServiceTypeProfilePage';
import { ServiceTypeDataTablePage } from '../../../pages/ServiceTypeDataTablePage/ServiceTypeDataTablePage';
import { ServiceEventSearchPage } from '../../../pages/ServiceEventSearchPage/ServiceEventSearchPage';
import { ServiceEventFormPageRoute } from '../../../pages/ServiceEventFormPage/ServiceEventFormPage';
import { ServiceTypeFormPageRoute } from '../../../pages/ServiceTypeFormPage/ServiceTypeFormPage';
import { ServiceEventTicketPolicyDataTablePageRoute } from '../../../pages/ServiceEventTicketPolicyDataTablePage/ServiceEventTicketPolicyDataTablePage';
import { ServiceEventTicketPolicyFormPageRoute } from '../../../pages/ServiceEventTicketPolicyFormPage/ServiceEventTicketPolicyFormPage';
import { ServiceEventProfilePageRoute } from '../../../pages/ServiceEventProfilePage/ServiceEventProfilePage';
import { ServiceEventTicketPolicyProfilePageRoute } from '../../../pages/ServiceEventTicketPolicyProfilePage/ServiceEventTicketPolicyProfilePage';
import { LocationStatusFacetFormPageRoute } from '../../../pages/LocationStatusFacetFormPage/LocationStatusFacetFormPage';
import { ServiceEventMapPageRoute } from '../../../pages/ServiceEventMapPage/ServiceEventMapPage';
import { CustomFieldProfileDataTablePageRoute } from '../../../pages/CustomFieldProfileDataTablePage/CustomFieldProfileDataTablePage';
import { CustomFieldDefDataTablePageRoute } from '../../../pages/CustomFieldDefDataTablePage/CustomFieldDefDataTablePage';
import { CustomFieldDefFormPageRoute } from '../../../pages/CustomFieldDefFormPage/CustomFieldDefFormPage';
import { CustomFieldProfileFormPageRoute } from '../../../pages/CustomFieldProfileFormPage/CustomFieldProfileFormPage';
import { TagDefinitionDataTablePageRoute } from '../../../pages/TagDefinitionDataTablePage/TagDefinitionDataTablePage';
import { TagCategoryDataTablePageRoute } from '../../../pages/TagCategoryDataTablePage/TagCategoryDataTablePage';
import { TagDefinitionFormPageRoute } from '../../../pages/TagDefinitionFormPage/TagDefinitionFormPage';
import { TagCategoryFormPageRoute } from '../../../pages/TagCategoryFormPage/TagCategoryFormPage';

const SystemProcessExecutionSearchPageRoute = lazy(() =>
  import('@ots-frontend/ots-ui-tw').then((module) => ({
    default: module.SystemProcessExecutionSearchPageRoute,
  }))
);
const SystemProcessExecutionProfilePageRoute = lazy(() =>
  import('@ots-frontend/ots-ui-tw').then((module) => ({
    default: module.SystemProcessExecutionProfilePageRoute,
  }))
);
const NotificationSubscriptionsPageRoute = lazy(() =>
  import('@ots-frontend/ots-ui-tw').then((module) => ({
    default: module.NotificationSubscriptionsPageRoute,
  }))
);
const NotificationTemplatesPage = lazy(() =>
  import('@ots-frontend/ots-ui-tw').then((module) => ({
    default: module.NotificationTemplatesPage,
  }))
);
const NotificationSenderProfilesPage = lazy(() =>
  import('@ots-frontend/ots-ui-tw').then((module) => ({
    default: module.NotificationSenderProfilesPage,
  }))
);
const NotificationReceiverProfilesPage = lazy(() =>
  import('@ots-frontend/ots-ui-tw').then((module) => ({
    default: module.NotificationReceiverProfilesPage,
  }))
);
const RestrictionsPageRoute = lazy(() =>
  import('@ots-frontend/ots-ui-tw').then((module) => ({
    default: module.RestrictionsPageRoute,
  }))
);
const SystemProcessRouteFallback = () => (
  <div className="p-6 text-sm">Loading system process logs…</div>
);
const RestrictionRouteFallback = () => (
  <div className="p-6 text-sm">Loading restrictions…</div>
);
const NotificationRouteFallback = () => (
  <div className="p-6 text-sm">Loading notification settings…</div>
);

export type OtsRouterProps = {
  persons?: {
    showStatus?: boolean;
  };
};

export const createOtsRouter = (props: OtsRouterProps = {}): ReactNode => {
  const { persons } = props;

  return (
    <>
      <Route
        id="abac-policies"
        path="abac-policies/*"
        element={<IndexComponent />}
      >
        <Route
          id="abac-policies-idx"
          index
          element={<ABACPolicyDataTablePageRoute />}
        />
        <Route
          id="abac-policies-profile"
          path="profile"
          element={<ABACPolicyProfilePageRoute />}
        />
        <Route
          id="abac-policies-form"
          path="form"
          element={<ABACPolicyFormPageRoute />}
        />
      </Route>

      <Route
        id="activity-period-profile-nested"
        path="activity-period/profile/*"
        element={<IndexComponent />}
        handle={{
          crumb: () => (
            <Anchor component={Link} to={`..`} key="activity_period_profile">
              Activity Period
            </Anchor>
          ),
        }}
      >
        <Route
          id="activity-period-profile-idx"
          index
          element={<ActivityPeriodProfilePageRoute />}
        />
        <Route
          id="activity-period-profile-tickets"
          path="tickets"
          element={<ActivityPeriodTicketDataTablePageRoute />}
        />
      </Route>

      <Route
        id="activity-period-profile"
        path="activity-period/profile"
        element={<ActivityPeriodProfilePageRoute />}
      />

      <Route id="chat" path="chat/*" element={<IndexComponent />}>
        <Route id="chat-idx" index element={<ChatPageRoute />} />
      </Route>

      <Route id="companies" path="companies/*" element={<IndexComponent />}>
        <Route id="companies-idx" index element={<CompanyDataTablePage />} />
        <Route
          id="companies-profile"
          path="profile"
          element={<CompanyProfilePageRoute />}
        />
      </Route>

      <Route id="compliance" path="compliance/*" element={<IndexComponent />}>
        <Route id="compliance-rrc" path="rrc/*" element={<IndexComponent />}>
          <Route index element={<RrcProfilesManager />} />
          <Route
            id="compliance-rrc-companies"
            path="companies/*"
            element={<IndexComponent />}
          >
            <Route index element={<RrcCompanyProfilesPageRoute />}/>
            <Route
              id="compliance-rrc-companies-profile"
              path="profile"
              element={<RrcCompanyProfileProfilePageRoute />}
            />
            <Route
              id="compliance-rrc-companies-keyprofile"
              path="key-profile"
              element={<RrcCompanyProfileKeyProfilePageRoute />}
            />
            <Route
              id="compliance-rrc-companies-form"
              path="form"
              element={<RrcCompanyProfileFormPageRoute />}
            />
          </Route>
          <Route
            id="compliance-rrc-ep9"
            path="ep9/*"
            element={<IndexComponent />}
          >
            <Route index element={<RrcEp9WasteProfilesPageRoute />} />
            <Route
              id="compliance-rrc-ep9-profile"
              path="profile"
              element={<RrcEp9WasteProfileProfilePageRoute />}
            />
            <Route
              id="compliance-rrc-ep9-keyprofile"
              path="key-profile"
              element={<RrcEp9WasteProfileKeyProfilePageRoute />}
            />
            <Route
              id="compliance-rrc-ep9-form"
              path="form"
              element={<RrcEp9WasteProfileFormPageRoute />}
            />
          </Route>
          <Route
            id="compliance-rrc-ep10"
            path="ep10/*"
            element={<IndexComponent />}
          >
            <Route
              id="compliance-rrc-ep10-profile"
              path="profile"
              element={<RrcEp10WasteManifestProfilePageRoute />}
            />
            <Route
              id="compliance-rrc-ep10-keyprofile"
              path="key-profile"
              element={<RrcEp10WasteManifestKeyProfilePageRoute />}
            />
          </Route>
          <Route
            id="compliance-rrc-locations"
            path="locations/*"
            element={<IndexComponent />}
          >
            <Route index element={<RrcLocationProfilesPageRoute />} />
            <Route
              id="compliance-rrc-locations-profile"
              path="profile"
              element={<RrcLocationProfileProfilePageRoute />}
            />
            <Route
              id="compliance-rrc-locations-keyprofile"
              path="key-profile"
              element={<RrcLocationProfileKeyProfilePageRoute />}
            />
            <Route
              id="compliance-rrc-locations-form"
              path="form"
              element={<RrcLocationProfileFormPageRoute />}
            />
          </Route>
        </Route>
      </Route>

      <Route id="containers" path="containers/*" element={<IndexComponent />}>
        <Route id="containers-idx" index element={<ContainerDataTablePage />} />
        <Route
          id="containers-form"
          path="form"
          element={<ContainerFormPageRoute />}
        />
        <Route
          id="containers-profile"
          path="profile"
          element={<ContainerProfilePageRoute />}
        />
        <Route
          id="containers-scada"
          path="scada"
          element={<ContainerLevelSearchPageRoute />}
        />
      </Route>

      <Route
        id="container-clusters"
        path="container-clusters/*"
        element={<IndexComponent />}
      >
        <Route
          id="container-clustesr-idx"
          index
          element={<ContainerClusterDataTablePageRoute />}
        />
        <Route
          id="container-clusters-profile"
          path="profile"
          element={<ContainerClusterProfilePageRoute />}
        />
      </Route>

      <Route
        id="custom-field-defs"
        path="custom-field-defs/*"
        element={<IndexComponent />}
      >
        <Route
          id="custom-field-defs-idx"
          index
          element={<CustomFieldDefDataTablePageRoute />}
        />
        <Route
          id="custom-field-defs-form"
          path="form"
          element={<CustomFieldDefFormPageRoute />}
        />
      </Route>

      <Route
        id="custom-field-profiles"
        path="custom-field-profiles/*"
        element={<IndexComponent />}
      >
        <Route
          id="custom-field-profiles-idx"
          index
          element={<CustomFieldProfileDataTablePageRoute />}
        />
        <Route
          id="custom-field-profiles-form"
          path="form"
          element={<CustomFieldProfileFormPageRoute />}
        />
      </Route>

      <Route id="geofences" path="geofences/*" element={<IndexComponent />}>
        <Route
          id="geofences-form"
          path="form"
          element={<GeofenceFormPageRoute />}
        />
      </Route>

      <Route
        id="geofence-site-groups"
        path="geofence-site-groups/*"
        element={<IndexComponent />}
      >
        <Route
          id="geofence-site-groups-idx"
          index
          element={<GeofenceSiteGroupDataTablePage />}
        />
        <Route
          id="geofence-site-groups-profile"
          path="profile"
          element={<GeofenceSiteGroupProfilePageRoute />}
        />
        <Route
          id="geofence-site-groups-form"
          path="form"
          element={<GeofenceSiteGroupFormPageRoute />}
        />
      </Route>

      <Route
        id="location-status-facets-form"
        path="location-statuses/form"
        element={<LocationStatusFacetFormPageRoute />}
      />

      <Route id="meters" path="meters/*" element={<IndexComponent />}>
        <Route id="meters-idx" index element={<MeterDataTablePage />} />
        <Route
          id="meters-profile"
          path="profile"
          element={<MeterProfilePageRoute />}
        />
        <Route id="meters-form" path="form" element={<MeterFormPageRoute />} />
      </Route>

      <Route id="permissions" path="permissions/*" element={<IndexComponent />}>
        <Route
          id="permissions-idx"
          index
          element={<PermissionDataTablePageRoute />}
        />
        <Route
          id="permissions-profile"
          path="profile"
          element={<PermissionProfilePageRoute />}
        />
      </Route>

      <Route id="persons" path="persons/*" element={<IndexComponent />}>
        <Route
          id="persons-idx"
          index
          element={<PersonDataTablePage showStatus={persons?.showStatus} />}
        />
        <Route
          id="persons-profile"
          path="profile"
          element={<PersonProfilePageRoute />}
        />
        <Route
          id="persons-form"
          path="form"
          element={<PersonFormPageRoute />}
        />
      </Route>

      <Route id="routes" path="routes/*" element={<IndexComponent />}>
        <Route id="routes-idx" index element={<RouteDataTablePage />} />
        <Route
          id="routes-profile"
          path="profile"
          element={<RouteProfilePageRoute />}
        />
      </Route>

      <Route id="sites" path="sites/*" element={<IndexComponent />}>
        <Route id="sites-idx" index element={<SiteDataTablePage />} />
        <Route id="sites-form" path="form" element={<SiteFormPageRoute />} />
        <Route
          id="sites-mileage"
          path="mileages"
          element={<SiteMileageDataTablePage />}
        />
        <Route
          id="sites-profile"
          path="profile"
          element={<SiteProfilePageRoute />}
        />
        <Route
          id="sites-profile-assignment-site-form"
          path="profile/assignments/site/form"
          element={<SiteSiteAssignmentFormPageRoute />}
        />
        <Route
          id="sites-profile-assignment-company-form"
          path="profile/assignments/company/form"
          element={<CompanySiteAssignmentFormPageRoute />}
        />
      </Route>

      <Route
        id="notifications"
        path="notifications/*"
        element={<IndexComponent />}
      >
        <Route
          id="notifications-index"
          index
          element={
            <Suspense fallback={<NotificationRouteFallback />}>
              <NotificationSubscriptionsPageRoute />
            </Suspense>
          }
        />
        <Route
          id="notifications-templates"
          path="templates/*"
          element={
            <Suspense fallback={<NotificationRouteFallback />}>
              <NotificationTemplatesPage />
            </Suspense>
          }
        />
        <Route
          id="notifications-sender-profiles"
          path="sender-profiles/*"
          element={
            <Suspense fallback={<NotificationRouteFallback />}>
              <NotificationSenderProfilesPage />
            </Suspense>
          }
        />
        <Route
          id="notifications-receiver-profiles"
          path="receiver-profiles/*"
          element={
            <Suspense fallback={<NotificationRouteFallback />}>
              <NotificationReceiverProfilesPage />
            </Suspense>
          }
        />
      </Route>

      <Route
        id="object-mappings-form"
        path="object-mappings/form"
        element={<ObjectMappingFormPageRoute />}
      />

      <Route
        id="object-combo-mappings-form"
        path="object-combo-mappings/form"
        element={<ObjectComboMappingFormPageRoute />}
      />

      <Route
        id="operating-areas"
        path="operating-areas/*"
        element={<IndexComponent />}
      >
        <Route
          id="operating-areas-idx"
          index
          element={<OperatingAreaDataTablePageRoute />}
        />
        <Route
          id="operating-areas-profile"
          path="profile"
          element={<OperatingAreaProfilePageRoute />}
        />
      </Route>

      <Route id="roles" path="roles/*" element={<IndexComponent />}>
        <Route id="roles-idx" index element={<RoleDataTablePageRoute />} />
        <Route
          id="roles-profile"
          path="profile"
          element={<RoleProfilePageRoute />}
        />
        <Route id="roles-form" path="form" element={<RoleFormPageRoute />} />
      </Route>

      <Route
        id="service-events"
        path="service-events/*"
        element={<IndexComponent />}
      >
        <Route
          id="service-events-idx"
          index
          element={<ServiceEventSearchPage />}
        />
        <Route
          id="service-events-profile"
          path="profile/*"
          element={<IndexComponent />}
        >
          <Route
            id="service-events-profile-idx"
            index
            element={<ServiceEventProfilePageRoute />}
          />
          <Route
            id="service-events-profile-map"
            path="map"
            element={<ServiceEventMapPageRoute />}
          />
        </Route>
        <Route
          id="service-events-form"
          path="form"
          element={<ServiceEventFormPageRoute />}
        />
      </Route>

      <Route
        id="service-event-ticket-policies"
        path="service-event-ticket-policies/*"
        element={<IndexComponent />}
      >
        <Route
          id="service-event-ticket-policies-idx"
          index
          element={<ServiceEventTicketPolicyDataTablePageRoute />}
        />
        <Route
          id="service-event-ticket-policies-profile"
          path="profile"
          element={<ServiceEventTicketPolicyProfilePageRoute />}
        />
        <Route
          id="service-event-ticket-policies-form"
          path="form"
          element={<ServiceEventTicketPolicyFormPageRoute />}
        />
      </Route>

      <Route
        id="service-types"
        path="service-types/*"
        element={<IndexComponent />}
      >
        <Route
          id="service-types-idx"
          index
          element={<ServiceTypeDataTablePage />}
        />
        <Route
          id="service-types-profile"
          path="profile"
          element={<ServiceTypeProfilePageRoute />}
        />
        <Route
          id="service-types-form"
          path="form"
          element={<ServiceTypeFormPageRoute />}
        />
      </Route>

      <Route
        id="site-assignment-site-bulk-form"
        path="site-assignments/site/bulk-form"
        element={<SiteSiteAssignmentBulkFormPageRoute />}
      />

      <Route
        id="site-assignment-company-bulk-form"
        path="site-assignments/company/bulk-form"
        element={<CompanySiteAssignmentBulkFormPageRoute />}
      />

      <Route id="tags" path="tags/*" element={<IndexComponent />}>
        <Route
          id="tags-definitions"
          path="definitions/*"
          element={<IndexComponent />}
        >
          <Route
            id="tags-definitions-idx"
            index
            element={<TagDefinitionDataTablePageRoute />}
          />
          <Route
            id="tags-definitions-form"
            path="form"
            element={<TagDefinitionFormPageRoute />}
          />
        </Route>
        <Route
          id="tags-categories"
          path="categories/*"
          element={<IndexComponent />}
        >
          <Route
            id="tags-categories-idx"
            index
            element={<TagCategoryDataTablePageRoute />}
          />
          <Route
            id="tags-categories-form"
            path="form"
            element={<TagCategoryFormPageRoute />}
          />
        </Route>
      </Route>

      <Route id="trailers" path="trailers/*" element={<IndexComponent />}>
        <Route
          id="trailers-idx"
          index
          element={<TrailerDataTablePage showStatus={true} />}
        />
        <Route
          id="trailers-profile"
          path="profile"
          element={<TrailerProfilePageRoute />}
        />
        <Route
          id="trailers-form"
          path="form"
          element={<TrailerFormPageRoute />}
        />
      </Route>

      <Route id="vehicles" path="vehicles/*" element={<IndexComponent />}>
        <Route id="vehicles-idx" index element={<VehicleDataTablePage />} />
        <Route
          id="vehicles-profile"
          path="profile"
          element={<VehicleProfilePageRoute />}
        />
        <Route
          id="vehicles-form"
          path="form"
          element={<VehicleFormPageRoute />}
        />
      </Route>

      <Route path="reports/*" element={<IndexComponent />}>
        <Route
          path="company-disposal"
          element={<CompanyDisposalReportFormPageRoute />}
        />
        <Route
          path="company-transport-services"
          element={<CompanyTransportServicesReportFormPageRoute />}
        />
        <Route path="dispute" element={<TtaDisputeReportFormPageRoute />} />
        <Route
          path="on-site-time"
          element={<OnSiteTimeReportFormPageRoute />}
        />
      </Route>

      <Route
        id="restrictions"
        path="restrictions/*"
        element={<IndexComponent />}
      >
        <Route
          id="restrictions-idx"
          index
          element={
            <Suspense fallback={<RestrictionRouteFallback />}>
              <RestrictionsPageRoute />
            </Suspense>
          }
        />
        <Route
          id="restriction-form"
          path="form"
          element={
            <Suspense fallback={<RestrictionRouteFallback />}>
              <RestrictionsPageRoute form />
            </Suspense>
          }
        />
      </Route>

      <Route id="wells" path="wells/*" element={<IndexComponent />}>
        <Route id="wells-idx" index element={<WellDataTablePage />} />
        <Route
          id="wells-profile"
          path="profile"
          element={<WellProfilePageRoute />}
        />
      </Route>

      <Route
        id="system-process-executions"
        path="system-process-executions/*"
        element={<IndexComponent />}
      >
        <Route
          id="system-process-executions-idx"
          index
          element={
            <Suspense fallback={<SystemProcessRouteFallback />}>
              <SystemProcessExecutionSearchPageRoute />
            </Suspense>
          }
        />
        <Route
          id="system-process-executions-profile"
          path="profile"
          element={
            <Suspense fallback={<SystemProcessRouteFallback />}>
              <SystemProcessExecutionProfilePageRoute />
            </Suspense>
          }
        />
      </Route>

      <Route
        id="transport-form-preference"
        path="system/transport-form-preference/*"
        element={<IndexComponent />}
      >
        <Route
          id="transport-form-preference-idx"
          index
          element={<TransportFormPreferencePageRoute />}
        />
      </Route>
    </>
  );
};
